export default __webpack_public_path__ + "static/media/brand.7f21d415.png";